(function(root){
  'use strict';
  var ids=Object.freeze(['standard','halloween','gta','neon']);
  var availableIds=Object.freeze(['standard','halloween','gta']);
  var names=Object.freeze({standard:'Standard',halloween:'Halloween',gta:'GTA · Vice',neon:'Néon'});
  var aliases=Object.freeze({standard:'standard',classique:'standard',halloween:'halloween',haloween:'halloween',gta:'gta',sunset:'gta',vice:'gta','gta vice':'gta','gta sunset':'gta','gta vi sunset':'gta',neon:'neon','edition neon':'neon'});
  function normalize(value){
    if(typeof value!=='string')return null;
    var key=value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[★·]/g,' ').replace(/\s+/g,' ').trim();
    if(key==='')return 'standard';
    return Object.prototype.hasOwnProperty.call(aliases,key)?aliases[key]:null;
  }
  function fromProperties(properties,recharge){
    var map=Object.create(null);
    if(Array.isArray(properties))properties.forEach(function(property){if(property&&typeof property.name==='string')map[property.name]=property.value;});
    else if(properties&&typeof properties==='object')Object.keys(properties).forEach(function(key){map[key]=properties[key];});
    var candidates=[];
    if(Object.prototype.hasOwnProperty.call(map,'_label_style'))candidates.push(map._label_style);
    if(recharge&&typeof recharge==='object'){
      if(Object.prototype.hasOwnProperty.call(recharge,'lt'))candidates.push(recharge.lt);
      if(Object.prototype.hasOwnProperty.call(recharge,'th'))candidates.push(recharge.th);
    }
    ['Étiquette','Style d’étiquette','Style d\'étiquette'].forEach(function(key){if(Object.prototype.hasOwnProperty.call(map,key))candidates.push(map[key]);});
    for(var i=0;i<candidates.length;i++){var id=normalize(candidates[i]);if(id!==null)return {id:id,explicit:true};}
    return {id:'standard',explicit:false};
  }
  function isAvailable(value){return availableIds.indexOf(normalize(value))!==-1;}
  function label(value){var id=normalize(value);return names[id||'standard'];}
  function withUrl(value,edition,explicit){
    var id=normalize(edition);
    if(!explicit||id===null)return value;
    try{var url=new URL(value);if(url.protocol!=='https:'&&url.protocol!=='http:')return value;url.searchParams.set('label',id);return url.toString();}catch(_){return value;}
  }
  root.MNL_LABEL_EDITIONS=Object.freeze({ids:ids,availableIds:availableIds,isAvailable:isAvailable,normalize:normalize,fromProperties:fromProperties,label:label,withUrl:withUrl});
})(typeof globalThis!=='undefined'?globalThis:window);
